/**
 * Para realizar la notificación a partidos el back necesita
 * el tipo de acta o monitoreo para realizar la consulta de beneficiados;
 */

export const TIPO_ACTA_INICIO = 1;
export const TIPO_ACTA_CIERRE = 3;
export const TIPO_HALLAZGO = 2;
export const TIPO_MEDIOS_IMPRESOS = 4;
export const TIPO_INTERNET = 5;
export const TIPO_VISITA_EVENTOS = 6;
export const TIPO_VISITA_CASAS = 7;

export const NO_NOTIFICADO = 0;
export const PARCIALMENTE_NOTIFICADO = 1;
export const NOTIFICADO = 2;
